module.exports = __webpack_public_path__ + "static/media/Medicine ID and Manufacturing Information.94e9531f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Medicine ID and Manufacturing Information.png
// module id = 1190
// module chunks = 0